import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

class NavItem extends Component {
	shouldComponentUpdate = ({
		icon,
		text,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(icon, lastProps.icon)
			|| !isEqual(text, lastProps.text)
		);
	}

	render() {
		const {
			icon,
			text,
		} = this.props;

		return (
			<div className="nav-item-wrapper">
				<If condition={!!icon}>
					<div className="icon-wrapper">
						<i className={icon} />
					</div>
				</If>
				<span>{ text }</span>
			</div>
		);
	}
}

NavItem.propTypes = {
	text : PropTypes.string.isRequired,
	icon : PropTypes.string,
};

NavItem.defaultProps = {
	icon : undefined,
};

export default NavItem;
